/** TC identifies its own hop; existing Standard branding stays unchanged elsewhere.
 * For Media Devoted | Created By Ciro Autiero */
import { matchTracker, trackerLabel } from '@trafficpulse/shared';
import { useFlowTracker } from '@/features/flow-optimizer/tracker/flow-tracker-context';

export function usePathTransitionTrackerName(): string | null {
  const tracker = useFlowTracker();
  if (!tracker) return null;
  return matchTracker(tracker, {
    voluum: () => null,
    binom: () => null,
    'tres-commas': () => trackerLabel(tracker),
  });
}
